'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { sendWebVitals } from './sendWebVitals';
import { type Device } from '../types';

export const WebVitals = ({ detectedDevice }: { detectedDevice: Device }) => {
  useReportWebVitals((metric) => {
    sendWebVitals(metric, detectedDevice);
  });
  return null;
};
